import React from "react";
import LogicIcon from "../../assets/icons/library_logic.svg2";
import DocumentIcon from "../../assets/icons/library_documents.svg2";
import BroadcastIcon from "../../assets/icons/prod_broadcast.svg2";
import ImportedContactsLibrary from "../../assets/icons/contacts_main.svg2";
import PageNavLink from "../Common/PageNavLink";
import ApiProfilesLibraryIcon from "../../assets/icons/icon_api_endpoints-01.svg2";
import ApiDataCollectionsLibraryIcon from "../../assets/icons/api_connections.svg2";
import PageNavLinks from "../Common/PageNavLinks";
import ComponentsLibraryIcon from "../../assets/icons/componenets.svg2";
import WeatherIcon from "../../assets/icons/icon_weather_header_c-01.svg2";
import CampaignIcon from "../../assets/icons/create_inbound.svg2";

export const libraryLinks = [
  {
    label: "Broadcast",
    Icon: BroadcastIcon,
    href: "/library/broadcast",
  },
  {
    label: "Import/Export Contacts",
    Icon: ImportedContactsLibrary,
    href: "/library/imported-contact-files",
  },
  {
    label: "Campaigns",
    Icon: CampaignIcon,
    href: "/library/campaigns",
  },
  {
    label: "Data structures",
    Icon: ApiDataCollectionsLibraryIcon,
    href: "/library/api-data-collections",
  },
  {
    label: "Logic Component",
    Icon: LogicIcon,
    href: "/library/logic",
  },
  {
    label: "API Connections",
    Icon: ApiProfilesLibraryIcon,
    href: "/library/api-connections",
  },

  {
    label: "Solutions",
    Icon: ComponentsLibraryIcon,
    href: "/library/solutions",
    newFeature: true,
  },
  {
    label: "Document",
    Icon: DocumentIcon,
    href: "/library/document",
    newFeature: false,
  },
  // {
  //   label: "API Profiles",
  //   Icon: ApiProfilesLibraryIcon,
  //   href: "/library/api-profiles",
  // },
];

export default function LibraryLinks({ rightSide }: { rightSide: any }) {
  return <PageNavLinks pageName="library" links={libraryLinks} />;
}
